<footer class="footer">

  <!-- mobile collapses -->
  <div class="mobile-only">
    <div class="collapse-container">
      <div class="collapse-link">

        <a href="https://n-somerset.gov.uk/my-services" class="title">Services</a>

        <button class="expand collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#servicesCollapse"
          aria-expanded="false" aria-controls="servicesCollapse" aria-label="services">
        </button>
      </div>

      <div class="collapse" id="servicesCollapse">
        <ul>
          <li><a href="https://n-somerset.gov.uk/my-services/adult-social-care-support">Adult social care and health</a>
          </li>
          <li><a href="https://n-somerset.gov.uk/my-services/benefits-support">Benefits and support</a></li>
          <li><a href="https://n-somerset.gov.uk/my-services/bins-recycling">Bins and recycling</a></li>
          <li><a href="https://n-somerset.gov.uk/my-services/births-marriages-deaths">Birth, marriages and deaths</a>
          </li>
          <li><a href="https://n-somerset.gov.uk/my-services/children-young-people-families">Children, young people and
              families</a></li>
          <li><a href="https://n-somerset.gov.uk/my-services/community-safety-crime">Community safety and crime</a></li>
          <li><a href="https://n-somerset.gov.uk/my-services/events">Events</a></li>
          <li><a href="https://n-somerset.gov.uk/my-services/housing">Housing</a></li>
          <li><a href="https://n-somerset.gov.uk/my-services/jobs-training">Jobs and training</a></li>
          <li><a href="https://n-somerset.gov.uk/my-services/libraries-leisure-open-spaces">Leisure, libraries and open
              spaces</a></li>
          <li><a href="https://n-somerset.gov.uk/my-services/north-somerset-together">North Somerset Together</a></li>
          <li><a href="https://n-somerset.gov.uk/my-services/nuisances-pollution-environmental-issues">Nuisances,
              pollution and environmental protection</a></li>
          <li><a href="https://n-somerset.gov.uk/my-services/parking-travel-roads">Parking, travel and roads</a></li>
          <li><a href="https://n-somerset.gov.uk/my-services/planning-building-control">Planning and building
              control</a>
          </li>
          <li><a href="https://n-somerset.gov.uk/my-services/schools-learning">Schools and learning</a></li>
        </ul>
      </div>
    </div>

    <div class="collapse-container">
      <div class="collapse-link">

        <a href="https://n-somerset.gov.uk/business" class="title">Business</a>

        <button class="expand collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#businessCollapse"
          aria-expanded="false" aria-controls="businessCollapse" aria-label="business">
        </button>
      </div>

      <div class="collapse" id="businessCollapse">
        <ul>
          <li><a href="https://n-somerset.gov.uk/business/business-rates-payments">Business rates and payments</a></li>
          <li><a href="https://n-somerset.gov.uk/business/business-support-advice">Business support and advice</a></li>
          <li><a href="https://n-somerset.gov.uk/business/environmental-health">Environmental health</a></li>
          <li><a href="https://n-somerset.gov.uk/business/health-safety">Health and safety</a></li>
          <li><a href="https://n-somerset.gov.uk/business/licences-permits">Licences and permits</a></li>
          <li><a href="https://n-somerset.gov.uk/business/regeneration-development">Regeneration and development</a></li>
          <li><a href="https://n-somerset.gov.uk/business/tenders-procurement">Tenders and procurement</a></li>
          <li><a href="https://n-somerset.gov.uk/business/trading-standards">Trading standards</a></li>
        </ul>
      </div>
    </div>

    <div class="collapse-container">
      <div class="collapse-link">

        <a href="https://n-somerset.gov.uk/council-democracy" class="title">My council</a>

        <button class="expand collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#myCouncilCollapse"
          aria-expanded="false" aria-controls="myCouncilCollapse" aria-label="my council">
        </button>
      </div>

      <div class="collapse" id="myCouncilCollapse">
        <ul>
          <li><a href="https://n-somerset.gov.uk/council-democracy/accounts-spending-insurance">Accounts, spending and
              insurance</a>
          </li>
          <li><a href="https://n-somerset.gov.uk/council-democracy/complaints-feedback">Complaints and feedback</a></li>
          <li><a href="https://n-somerset.gov.uk/council-democracy/councillors-committees">Councillors and committees</a>
          </li>
          <li><a href="https://n-somerset.gov.uk/council-democracy/data-protection-freedom-information">Data protection
              and freedom
              of information</a></li>
          <li><a href="https://n-somerset.gov.uk/council-democracy/equality-diversity-inclusion">Equalities</a></li>
          <li><a href="https://n-somerset.gov.uk/council-democracy/get-involved">Get involved</a></li>
          <li><a href="https://n-somerset.gov.uk/council-democracy/news-media">News and media</a></li>
          <li><a href="https://n-somerset.gov.uk/council-democracy/priorities-strategies">Priorities and strategies</a>
          </li>
          <li><a href="https://n-somerset.gov.uk/council-democracy/north-somerset-insight-data-statistics">Statistics and
              data</a></li>
          <li><a href="https://n-somerset.gov.uk/council-democracy/voting-elections">Voting and elections</a></li>
        </ul>
      </div>
    </div>

     <div class="collapse-container">
      <div class="collapse-link">
        <a href="https://n-somerset.gov.uk/news" class="title">News</a>
      </div>
    </div>
  </div>

  <!-- mobile collapses end -->


  <div class="help">
    <ul class="social-media">
      <li><a href="https://www.facebook.com/northsomersetcouncil" aria-label="social media facebook"><fa-icon
            [icon]="faFacebookF"></fa-icon></a></li>
      <li><a href="https://twitter.com/NorthSomersetC" aria-label="social media X"><fa-icon [icon]="faX"></fa-icon></a>
      </li>
      <li><a href="https://www.youtube.com/user/NorthSomersetCouncil" aria-label="social media youtube"><fa-icon
            [icon]="faYoutube"></fa-icon></a></li>
      <li><a href="https://www.instagram.com/northsomersetlife/?hl=en" aria-label="social media instagram"><fa-icon
            [icon]="faInstagram"></fa-icon></a></li>
      <li><a href="http://www.linkedin.com/company/north-somerset-council" aria-label="social media linkedin"><fa-icon
            [icon]="faLinkedIn"></fa-icon></a></li>
    </ul>

    <ul class="main-nav">
      <li>
        <a href="https://n-somerset.gov.uk/council-democracy/equality-diversity-inclusion/accessibility-statement"
          title="Accessibility statement">Accessibility</a>
      </li>
      <li>
        <a href="https://n-somerset.gov.uk/contact-us" title="Contact us">Contact us</a>
      </li>
      <li>
        <a href="https://n-somerset.gov.uk/council-democracy/privacy-cookies" title="Privacy and cookies">Privacy and
          cookies</a>
      </li>
      <li>
        <a href="https://n-somerset.gov.uk/do-it-online/help-getting-online" title="support">Support</a>
      </li>
      <li>
        <a href="https://n-somerset.gov.uk/council-democracy/privacy-cookies/terms" title="Terms">Terms</a>
      </li>
    </ul>

    <div class="feedback-container">
      <div class="feedback">

        <a href="https://websurveys2.govmetric.com/theme/gm/9990045" target="_blank" class="gm_sidebar_anchor"
          title="Share your feedback" rel="nofollow">
          Did you find what you were looking for?
          <i class="ph ph-arrow-square-up-right"></i>
        </a>
      </div>
    </div>
  </div>

  <div class="links desktop-only">
    <div class="list">
      <a href="https://n-somerset.gov.uk/my-services" class="title">Services</a>
      <ul>
        <li><a href="https://n-somerset.gov.uk/my-services/adult-social-care-support">Adult social care and health</a>
        </li>
        <li><a href="https://n-somerset.gov.uk/my-services/benefits-support">Benefits and support</a></li>
        <li><a href="https://n-somerset.gov.uk/my-services/bins-recycling">Bins and recycling</a></li>
        <li><a href="https://n-somerset.gov.uk/my-services/births-marriages-deaths">Birth, marriages and deaths</a></li>
        <li><a href="https://n-somerset.gov.uk/my-services/children-young-people-families">Children, young people and
            families</a></li>
        <li><a href="https://n-somerset.gov.uk/my-services/community-safety-crime">Community safety and crime</a></li>
        <li><a href="https://n-somerset.gov.uk/my-services/events">Events</a></li>
        <li><a href="https://n-somerset.gov.uk/my-services/housing">Housing</a></li>
        <li><a href="https://n-somerset.gov.uk/my-services/jobs-training">Jobs and training</a></li>
        <li><a href="https://n-somerset.gov.uk/my-services/libraries-leisure-open-spaces">Leisure, libraries and open
            spaces</a></li>
        <li><a href="https://n-somerset.gov.uk/my-services/north-somerset-together">North Somerset Together</a></li>
        <li><a href="https://n-somerset.gov.uk/my-services/nuisances-pollution-environmental-issues">Nuisances,
            pollution and environmental protection</a></li>
        <li><a href="https://n-somerset.gov.uk/my-services/parking-travel-roads">Parking, travel and roads</a></li>
        <li><a href="https://n-somerset.gov.uk/my-services/planning-building-control">Planning and building control</a>
        </li>
        <li><a href="https://n-somerset.gov.uk/my-services/schools-learning">Schools and learning</a></li>
      </ul>
    </div>

    <div class="list">
      <a href="https://n-somerset.gov.uk/business" class="title">Business</a>
      <ul>
        <li><a href="https://n-somerset.gov.uk/business/business-rates-payments">Business rates and payments</a></li>
        <li><a href="https://n-somerset.gov.uk/business/business-support-advice">Business support and advice</a></li>
        <li><a href="https://n-somerset.gov.uk/business/environmental-health">Environmental health</a></li>
        <li><a href="https://n-somerset.gov.uk/business/health-safety">Health and safety</a></li>
        <li><a href="https://n-somerset.gov.uk/business/licences-permits">Licences and permits</a></li>
        <li><a href="https://n-somerset.gov.uk/business/regeneration-development">Regeneration and development</a></li>
        <li><a href="https://n-somerset.gov.uk/business/tenders-procurement">Tenders and procurement</a></li>
        <li><a href="https://n-somerset.gov.uk/business/trading-standards">Trading standards</a></li>
      </ul>
    </div>

    <div class="list">
      <a href="https://n-somerset.gov.uk/council-democracy" class="title">My council</a>
      <ul>
        <li><a href="https://n-somerset.gov.uk/council-democracy/accounts-spending-insurance">Accounts, spending and
            insurance</a>
        </li>
        <li><a href="https://n-somerset.gov.uk/council-democracy/complaints-feedback">Complaints and feedback</a></li>
        <li><a href="https://n-somerset.gov.uk/council-democracy/councillors-committees">Councillors and committees</a>
        </li>
        <li><a href="https://n-somerset.gov.uk/council-democracy/data-protection-freedom-information">Data protection
            and freedom
            of information</a></li>
        <li><a href="https://n-somerset.gov.uk/council-democracy/equality-diversity-inclusion">Equalities</a></li>
        <li><a href="https://n-somerset.gov.uk/council-democracy/get-involved">Get involved</a></li>
        <li><a href="https://n-somerset.gov.uk/council-democracy/news-media">News and media</a></li>
        <li><a href="https://n-somerset.gov.uk/council-democracy/priorities-strategies">Priorities and strategies</a>
        </li>
        <li><a href="https://n-somerset.gov.uk/council-democracy/north-somerset-insight-data-statistics">Statistics and
            data</a></li>
        <li><a href="https://n-somerset.gov.uk/council-democracy/voting-elections">Voting and elections</a></li>
      </ul>
      <a href="https://n-somerset.gov.uk/news" class="title">News</a>
    </div>
  </div>


</footer>